module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "form-group",
    class: [_vm.className, {
      "form-error": _vm.internalErrors.length
    }]
  }, [(_vm.maxlength) ? _c('div', {
    staticClass: "char-counter"
  }, [_vm._v(_vm._s(_vm.charCounterValue))]) : _vm._e(), (!this.$slots["label"] && _vm.label) ? _c('label', {
    staticClass: "label",
    attrs: {
      "for": String(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.tooltip) ? _c('span', {
    staticClass: "tooltip-custom"
  }, [_c('icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-circle",
      "scale": "1.25"
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.tooltip))])]) : _vm._t("label"), (!this.$slots["input"]) ? _c('b-form-input', {
    attrs: {
      "id": String(_vm._uid),
      "type": _vm.type,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "textarea": _vm.textarea,
      "rows": _vm.rows,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "maxlength": _vm.maxlength
    },
    on: {
      "input": _vm.onInput,
      "change": _vm.onChange
    }
  }) : _vm._t("input"), (_vm.internalErrors.length) ? _c('ul', {
    staticClass: "errors-list"
  }, _vm._l((_vm.internalErrors), function(e) {
    return _c('li', [_vm._v(_vm._s(e))])
  })) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bfc3f06"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-input/FormInput.vue
// module id = 950
// module chunks = 1